import { encryptObject } from "@/helpers/noncehelper";
import { fetchDataFromAlgoliaById, getEnrichList, getPayloadForAlgolia } from "@/services/algolia";
import {
  addRecipeList,
  getRecipeList,
  addRecipeToList,
  deleteRecipeList,
  mergeRecipeList,
  deleteRecipe,
  addRecipeLists,
} from "@/services/recipes";
import { fetchSafeJson } from "@/utils/apiResponse";
import { encrypt } from "@/utils/encrypt";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const createRecipeListAction = createAsyncThunk(
  "/create-list",
  async (payload: any) => {
    try {
      const res = await addRecipeLists(encryptObject(payload));
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getRecipeListAction = createAsyncThunk(
  "/get_list",
  async (payload: any) => {
    try {
      const res = await getRecipeList(encryptObject({ token: payload.token }));
      const data: any = await fetchSafeJson(res);
      return data?.response;
    } catch (error) {
      console.log(error);
    }
  }
);

export const createRecipeToListAction = createAsyncThunk(
  "/create-list",
  async (payload: any) => {
    try {
      const res = await addRecipeToList(encryptObject(payload));
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deleteRecipeListsAction = createAsyncThunk(
  "recipes/deleteRecipeLists",
  async (payload: any, { rejectWithValue }) => {
    try {
      const { toBeDeletedList, token } = payload;
      if (!Array.isArray(toBeDeletedList)) {
        throw new Error("Payload must be an array of recipe list IDs");
      }

      const recipe_list_ids = toBeDeletedList.join(",");

      const response = await deleteRecipeList(
        encryptObject({ recipeLists: recipe_list_ids, token })
      );
      return response;
    } catch (error: any) {
      console.error("Error deleting recipe lists:", error);

      // Pass error to `rejected` state
      return rejectWithValue({
        message: error.message,
        status: error.code,
      });
    }
  }
);

export const mergeRecipeListsAction = createAsyncThunk(
  "recipes/mergeRecipeLists",
  async (payload: any, { rejectWithValue }) => {
    try {
      const { token, ...rest } = payload;
      const response = await mergeRecipeList(
        encryptObject({ data: rest, token })
      );
      return response;
    } catch (error: any) {
      console.error("Error deleting recipe lists:", error);

      // Pass error to `rejected` state
      return rejectWithValue(error || "An unexpected error occurred");
    }
  }
);

export const deleteRecipeAction = createAsyncThunk(
  "recipes/deleteRecipes",
  async (payload: any, { rejectWithValue }) => {
    try {
      const { token, ...rest } = payload;
      const response = await deleteRecipe(encryptObject({ data: rest, token }));
      return response;
    } catch (error: any) {
      console.error("Error deleting recipe lists:", error);

      // Pass error to `rejected` state
      return rejectWithValue({
        message: error.message,
        status: error.code,
      });
    }
  }
);